<template>
    <v-btn-toggle>
        <v-btn color="green" class="white--text" @click="EditCallBack" height="25" v-if="Edit" outlined :loading="loading" :disabled="loading">{{EditText}} <v-icon color="green" right>mdi mdi-clipboard-edit</v-icon> </v-btn>
        <v-btn color="red" class="white--text" @click="RemoveCallBack" height="25" v-if="Remove"  :loading="loading" :disabled="loading" outlined>Xóa <v-icon color="red" right>delete</v-icon> </v-btn>
    </v-btn-toggle>
</template>
<script>
export default {
    data: () => ({
      loading: false,
    }),
    props: {
      Item: {
        type: Object,
        default: ()=>{
          return {};
        },
        required: false
      },
      Items: {
        type: Array,
        default: ()=>{
          return [];
        },
        required: false
      },
      Edit:{
        type: Boolean,
        default: true,
        required: false
      },
      EditText:{
        type: String,
        default: "Sửa",
        required: false
      },
      Remove:{
        type: Boolean,
        default: false,
        required: false
      },
      EditFunc:{
        type: Function,
        default: undefined,
        required: false
      },
      DeleteFunc:{
        type: Function,
        default: undefined,
        required: false
      },
    },
    methods: {
      async EditCallBack()
      {
        if(this.EditFunc !== undefined){
          this.loading = true;
          if(this.Items !== []) await this.EditFunc(this.Items);
          if(this.Item !== {}) await this.EditFunc(this.Item);
          this.loading = false;
        }
      },
      async RemoveCallBack()
      {
        if(this.EditFunc !== undefined){
          this.loading = true;
          if(this.Items !== []) await this.DeleteFunc(this.Items);
          if(this.Item !== {}) await this.DeleteFunc(this.Item);
          this.loading = false;
        }
      },
    },
    watch: {
      
    },
    computed: {
      
    },
    mounted(){

    }
}
</script>